import styled from '@emotion/styled';
import Theme from 'App.theme';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;

  table td {
    padding: unset;

    a {
      display: flex;
      align-items: center;
      justify-content: start;
      height: 100%;
      width: 100%;
      padding: 16px;
      line-height: 1.43;
      max-width: 15rem;
      text-decoration: none;
      color: ${Theme.colours.black};
    }
  }
`;

export const ConfigContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 0.5rem;
  gap: 1.5rem;
`;

export const SearchContainer = styled.div`
  width: 50%;
`;

export const FilterContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;
